import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';

export class StyleOneMustContent extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data } = this.props;
    return (
      <div className="topic-style-one-must-content">
        <div className='must_content_box flex_row'>
          <div className='must_left_box'>
            <div className='must_left_title flex_row'>{Data.inline_title}</div>
            <div className='must_left_content'>{Data.inline_tips}</div>
            <div className='must_left_list'>
              {Data.inline_list && Data.inline_list.map(item => <div className='must_left_item flex_row' key={item.id}>
                <div className='left_item_title'>{item.title}</div>
                <div className='left_item_content'>{item.content}</div>
              </div>)}
            </div>
          </div>
          <div className='must_right_box flex_row'>
            {Data.downloadData && Data.downloadData.map(item => <div className='must_right_item' key={item.id}>
              <div className='right_item_bg flex_row'>
                <div className='right_item_title'>{item.title}</div>
              </div>
              <div className='right_item_btn flex_row'>下载</div>
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneMustContent);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneMustContent.js